module.exports = __webpack_public_path__ + "assets/img/24_323_big.05ad4444.jpg";